import {useEffect, useRef} from "react";
import {shallowEqual} from "react-redux";

export default function useShallowCompareEffect(callback, deps) {
    const prevDepsRef = useRef();

    useEffect(() => {
        if(!shallowEqual(prevDepsRef.current, deps)) {
            prevDepsRef.current = deps;
            callback();
        }
    }, [callback, deps]);
}